/* eslint-disable no-shadow */
import { authenticationService } from '../_services';
import router from '../_router';
import { EventBus } from '../components/EventBus';

const state = {
    status: {},
    token: '',
    student_uuid: '',
    starred_amount: 0,
    chart_group: '',
    answered_region: false,
    checked_region: false,
    answered_area: false,
    checked_area: false,
    seen_video: false,
    checked_video: false,
    student_data: {},
    video_trigger: false,
    university_trigger: false,
    ranking_trigger: false,
    favourites_trigger: false,
};

const actions = {
    /* eslint-disable-next-line no-unused-vars */
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest');
        return authenticationService.login(
            username,
            password,
        ).then((response) => {
            commit('loginSuccess', response);
        }).catch((error) => {
            commit('loginFailure', error);
            throw error;
        });
    },
    logout({ commit }) {
        authenticationService.logout();
        commit('logout');
        router.push({ name: 'home' });
    },
    triggeredVideoOverlay({ commit }) {
        commit('triggeredVideoOverlayMutation');
    },
    triggeredRankingOverlay({ commit }) {
        commit('triggeredRankingOverlayMutation');
    },
    triggeredUniversityOverlay({ commit }) {
        commit('triggeredUniversityOverlayMutation');
    },
    triggeredFavouritesOverlay({ commit }) {
        commit('triggeredFavouritesOverlayMutation');
    },
    setQuestionsToAnswered({ commit }) {
        commit('answerQuestions');
    },
};

const mutations = {
    loginRequest(state) {
        state.status = {
            loggingIn: true,
        };
    },
    loginSuccess(state, response) {
        state.status = {
            loggedIn: true,
        };
        state.token = response.data.key;
        state.student_uuid = response.data.student.uuid;
        state.starred_amount = response.data.student.starred_amount;
        state.chart_group = response.data.student.chart_group;
        state.student_data = response.data.student;
        state.video_trigger = response.data.student.video_trigger;
        state.ranking_trigger = response.data.student.ranking_trigger;
        state.university_trigger = response.data.student.university_trigger;
        state.favourites_trigger = response.data.student.favourites_trigger;
        this.dispatch('careers/cleanAnsweredCareer');
    },
    linkStaticData(state, responseData) {
        state.student_uuid = responseData.uuid;
        state.student_data = responseData;
        this.dispatch('careers/cleanAnsweredCareer');
    },
    clearStaticData(state) {
        state.student_uuid = '';
        state.student_data = {};
    },
    loginFailure(state, error) {
        state.status = {
            error: error.response.data,
        };
    },
    logout(state) {
        state.status = {};
        state.token = '';
        state.student_uuid = '';
        state.starred_amount = 0;
        state.chart_group = '';
        state.student_data = {};
        state.answered_region = false;
        state.checked_region = false;
        state.answered_area = false;
        state.checked_area = false;
        state.seen_video = false;
        state.checked_video = false;
        this.dispatch('clippyNotifications/clearAll');
        this.dispatch('careers/cleanAnsweredCareer');
    },
    addStar(state) {
        state.starred_amount += 1;
        if (state.starred_amount >= 4) {
            this.dispatch('clippyNotifications/addDirectMessage', 'ADD_MORE_THAN_X_FAVORITE');
            EventBus.$emit('showOverlayFavourites');
        }
    },
    answerQuestions(state) {
        state.student_data.question_answered = true;
    },
    removeStar(state) {
        state.starred_amount -= 1;
    },
    answeredArea(state) {
        state.answered_area = true;
    },
    answeredRegion(state) {
        state.answered_region = true;
    },
    checkedArea(state) {
        state.checked_area = true;
    },
    checkedRegion(state) {
        state.checked_region = true;
    },
    seenVideo(state) {
        state.seen_video = true;
    },
    checkedVideo(state) {
        state.checked_video = true;
    },
    triggeredVideoOverlayMutation(state) {
        state.video_trigger = false;
    },
    triggeredRankingOverlayMutation(state) {
        state.ranking_trigger = false;
    },
    triggeredUniversityOverlayMutation(state) {
        state.university_trigger = false;
    },
    triggeredFavouritesOverlayMutation(state) {
        state.favourites_trigger = false;
    },
};

const getters = {
    token: storeState => storeState.token,
    student_uuid: storeState => storeState.student_uuid,
    status: storeState => storeState.status,
    starred_amount: storeState => storeState.starred_amount,
    is_logged_in: storeState => storeState.status.loggedIn,
    chart_group: storeState => storeState.chart_group,
    answered_area: storeState => storeState.answered_area,
    checked_area: storeState => storeState.checked_area,
    answered_region: storeState => storeState.answered_region,
    checked_region: storeState => storeState.checked_region,
    student_data: storeState => storeState.student_data,
    seen_video: storeState => storeState.seen_video,
    checked_video: storeState => storeState.checked_video,
    video_trigger: storeState => storeState.video_trigger,
    university_trigger: storeState => storeState.university_trigger,
    ranking_trigger: storeState => storeState.ranking_trigger,
    favourites_trigger: storeState => storeState.favourites_trigger,

    has_rne: (storeState) => {
        const { rne } = storeState.student_data;
        return rne;
    },
    question_answered: storeState => storeState.student_data.question_answered,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
